import React from "react";

import { EventContext, SportOfferContext } from "@gp/components";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { observer } from "mobx-react";

import { AdditionalOfferEvent } from ".";

export const AdditionalOfferCore = observer(
	function AdditionalOfferCore(props: { store: AdditionalOfferViewStore }) {
		if (props.store.isLoading) {
			return (
				<div className="event event--loading">
					<div className="loader">
						<div className="loader__spinner loader__spinner--primary" />
					</div>
				</div>
			);
		}

		return (
			<>
				{props.store.events.map((event) => (
					<SportOfferContext.Provider
						//@ts-expect-error
						key={event?.sport?.id + event?.id}
						//@ts-expect-error
						value={event?.sport}
					>
						<EventContext.Provider value={event}>
							<AdditionalOfferEvent />
						</EventContext.Provider>
					</SportOfferContext.Provider>
				))}
			</>
		);
	}
);
